export default function EditableCardHeader() {
    return null;
}
